import React from "react";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";

function CardMetric({ measurementKey, metricLabel, effectiveSuffix, formatedValue, darkMode }) {
  return (
    <MDBox
      key={measurementKey}
      style={{
        border: darkMode ? "1px solid #26304b" : "1px solid #e5e7eb",
        borderRadius: 12,
        padding: 12,
        background: darkMode ? "#1a2035" : "#ffffff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <MDBox
        style={{
          fontSize: 14,
          color: darkMode ? "#f8fafc" : "#64748b",
          marginBottom: 6,
          textAlign: "center",
          width: "100%",
        }}
      >
        {metricLabel}
        {effectiveSuffix ? (
          <span
            style={{ marginLeft: 4, color: darkMode ? "#f8fafc" : "#64748b" }}
          >{`(${effectiveSuffix})`}</span>
        ) : null}
      </MDBox>
      <MDBox style={{ fontSize: 18, fontWeight: 700, color: darkMode ? "#f8fafc" : "#0f172a" }}>
        {formatedValue || "—"}
      </MDBox>
    </MDBox>
  );
}

CardMetric.defaultProps = {
  measurementKey: "",
  metricLabel: "",
  effectiveSuffix: "",
  formatedValue: "",
  darkMode: false,
};

CardMetric.propTypes = {
  measurementKey: PropTypes.string,
  metricLabel: PropTypes.string,
  effectiveSuffix: PropTypes.string,
  formatedValue: PropTypes.string,
  darkMode: PropTypes.bool,
};

export default CardMetric;
